export default __webpack_public_path__ + "static/media/Beats.fe1c3062.svg";